import { useState, useEffect, useRef } from 'react';
import { X, Delete, Percent, Divide, Plus, Minus, Equal } from 'lucide-react';

const Calculator = ({ onClose }) => {
  const [input, setInput] = useState('');
  const [result, setResult] = useState('');
  const inputRef = useRef(null);

  const handleClick = (value) => {
    if (value === 'C') {
      setInput('');
      setResult('');
    } else if (value === '⌫') {
      const el = inputRef.current;
      const start = el.selectionStart;
      const end = el.selectionEnd;
      const updated =
        start === end
          ? input.slice(0, start - 1) + input.slice(end)
          : input.slice(0, start) + input.slice(end);
      setInput(updated);
      setTimeout(() => {
        el.setSelectionRange(start - 1, start - 1);
      }, 0);
    } else if (value === '=') {
      try {
        const evalResult = eval(input.replace(/×/g, '*').replace(/÷/g, '/'));
        let formatted = evalResult.toString();
        if (formatted.length > 14) {
          formatted = formatted.slice(0, 15) + 'E';
        }
        setResult(formatted);
      } catch {
        setResult('Error');
      }
    } else {
      const el = inputRef.current;
      const start = el.selectionStart;
      const end = el.selectionEnd;
      const updated = input.slice(0, start) + value + input.slice(end);
      setInput(updated);
      setTimeout(() => {
        el.setSelectionRange(start + value.length, start + value.length);
      }, 0);
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
        handleClick('=');
      } else if (e.key === 'Escape') {
        handleClick('C');
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [input]);

  const buttons = [
    { label: 'C' },
    { label: '⌫', icon: <Delete size={20} /> },
    { label: '%', icon: <Percent size={20} /> },
    { label: '÷', icon: <Divide size={20} /> },
    { label: '7' }, { label: '8' }, { label: '9' }, { label: '×', icon: <X size={20} /> },
    { label: '4' }, { label: '5' }, { label: '6' }, { label: '-', icon: <Minus size={20} /> },
    { label: '1' }, { label: '2' }, { label: '3' }, { label: '+', icon: <Plus size={20} /> },
    { label: '0' }, { label: '00' }, { label: '.' }, { label: '=', icon: <Equal size={20} /> },
  ];

  return (
    <div className="w-64  text-white p-4 rounded-xl shadow-xl hover:shadow-[2px_2px_22px_rgba(0,112,112,0.6)]">
      <div className="flex justify-between items-center mb-10 text-sm text-zinc-800 border-b border-zinc-500">
        <span>Calculator</span>
        <button className="text-blue-600 hover:text-greenBg" onClick={onClose}>Close</button>
      </div>

      <input
        ref={inputRef}
        type="text"
        className="w-full text-right text-zinc-600 text-sm bg-transparent outline-none break-all"
        value={input}
        onChange={(e) => setInput(e.target.value)}
      />

      <div className="text-right text-greenBg text-2xl font-bold mb-2 break-words">
        {result}
      </div>

      <div className="grid grid-cols-4 gap-2">
        {buttons.map((btn) => {
          const isNumber = /^[0-9.]+$/.test(btn.label);
          return (
            <button
              key={btn.label}
              onClick={() => handleClick(btn.label)}
               className={`p-[6px] rounded-2xl text-2xl flex items-center justify-center transition-colors duration-200 ${
  isNumber
    ? 'bg-greenBg text-white hover:bg-white hover:text-greenBg hover:shadow-[2px_2px_22px_rgba(0,112,112,0.6)]'
    : 'bg-zinc-800  text-white hover:bg-white hover:text-greenBg hover:shadow-[2px_2px_22px_rgba(0,112,112,0.6)]'
}`}

            >
              {btn.icon || btn.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Calculator;
